import React, { useState, useEffect } from "react";
import { Modal, Image } from "react-bootstrap";
import "./TwoFactorModal.scss";

const TwoFactorModal = ({
  open,
  onClose,
  qrCode,
  manualEntryKey,
  onVerifyOtp,
  loading = false,
  error = "",
}) => {
  const [otp, setOtp] = useState("");
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    if (!open) {
      setOtp("");
      setLocalError("");
    }
  }, [open]);

  const handleCopy = async () => {
    if (!manualEntryKey || !navigator?.clipboard) return;
    try {
      await navigator.clipboard.writeText(manualEntryKey);
      setLocalError("Key copied to clipboard");
      setTimeout(() => setLocalError(""), 2000);
    } catch (e) {
      setLocalError("Unable to copy. Please copy manually.");
    }
  };

  const handleVerify = () => {
    if (!otp || otp.length !== 6) {
      setLocalError("Enter the 6 digit code from Google Authenticator.");
      return;
    }
    setLocalError("");
    onVerifyOtp && onVerifyOtp(otp);
  };

  const displayError = error || localError;

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(value);
    setLocalError("");
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      animation
      dialogClassName="twofactor-modal-dialog"
      contentClassName="twofactor-modal-content"
    >
      <Modal.Header className="twofactor-modal-header">
        <Modal.Title>Setup Google Authenticator</Modal.Title>
        <button
          type="button"
          className="twofactor-close"
          aria-label="Close"
          onClick={onClose}
        >
          &times;
        </button>
      </Modal.Header>
      <Modal.Body className="twofactor-modal-body">
        <div className="twofactor-modal-qr-container">
          {qrCode ? (
            <Image
              src={qrCode}
              alt="2FA QR code"
              className="twofactor-modal-qr"
              fluid
            />
          ) : (
            <p className="text-muted mb-0">QR code unavailable</p>
          )}
        </div>
        <div className="twofactor-manual-key">
          <label>Manual Entry Key</label>
          <div className="manual-key-input">
            <span className="manual-key-text">{manualEntryKey || "-"}</span>
            {manualEntryKey && (
              <button type="button" onClick={handleCopy}>
                Copy
              </button>
            )}
          </div>
        </div>
        <div className="twofactor-otp-input">
          <label htmlFor="twofactor-otp">Enter OTP</label>
          <input
            id="twofactor-otp"
            type="text"
            placeholder="Enter 6 digit code"
            value={otp}
            inputMode="numeric"
            autoComplete="one-time-code"
            onChange={handleInputChange}
            maxLength={6}
          />
          {displayError && (
            <div className="twofactor-error">{displayError}</div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="twofactor-modal-footer">
        <button
          type="button"
          className="twofactor-btn twofactor-btn-cancel"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="twofactor-btn twofactor-btn-verify"
          onClick={handleVerify}
          disabled={loading}
        >
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TwoFactorModal;

